import { Subscription } from "@/shared/client";

/**
 * Check if a subscription is active and allows access to services
 * Active statuses: 'active' and 'trialing'
 * Inactive statuses: 'canceled', 'past_due', 'paused', or null
 */
export const hasActiveSubscription = (
  subscription: Subscription | null | undefined
): boolean => {
  if (!subscription) return false;

  return subscription.status === "active" || subscription.status === "trialing";
};

/**
 * Check if subscription status allows service access
 */
export const isSubscriptionStatusActive = (
  status: Subscription["status"] | null | undefined
): boolean => {
  return status === "active" || status === "trialing";
};
